import * as analytics from './googleAnalytics';

export default analytics;
